module.exports = __webpack_public_path__ + "img/speaker-NikaAmashukeli.2a60bdf9.png";